import { render, staticRenderFns } from "./Summernote.vue?vue&type=template&id=1c696cc8"
import script from "./Summernote.vue?vue&type=script&lang=js"
export * from "./Summernote.vue?vue&type=script&lang=js"
import style0 from "./Summernote.vue?vue&type=style&index=0&id=1c696cc8&prod&lang=css"
import style1 from "./Summernote.vue?vue&type=style&index=1&id=1c696cc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports